import React, { FC, useState } from "react"
import { Grid, InputLabel } from "@material-ui/core"

import BaseSnoozeDialog from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/BaseSnoozeDialog"
import Messages from "@/pages/Attendance/Chat/ConversationPanel/ConversationHeader/NewSnooze/components/Messages"
import { BuildedMessage } from "@/protocols/messages"

type SimpleMessageDialogProps = {
	inboxChannelChatId: number
	defaultOpen?: boolean
	onClose: () => void
	userId: number
	instanceId: number
}

const SimpleMessageDialog: FC<SimpleMessageDialogProps> = (props) => {
	const {
		defaultOpen = false,
		children,
		onClose,
		userId,
		instanceId
	} = props

	const [messages, setMessages] = useState<BuildedMessage[]>([])
	const [openSimpleMessageDialog, setOpenSimplesMessageDialog] = useState<boolean>(defaultOpen)

	const handleOpenSimplesMessageDialog = () => {
		setOpenSimplesMessageDialog(true)
	}

	const handleCloseSimplesMessageDialog = () => {
		setOpenSimplesMessageDialog(false)
		onClose()
	}

	const isSaveButtonDisabled = React.useMemo(() => {
		const emptyContentMessage = !messages[0]?.content?.length
		const isDeletedMessage = messages[0]?.status === "DELETED"
		const noMessages = !messages.length

		if ((noMessages || emptyContentMessage || isDeletedMessage)) {
			return true
		}

		return false
	}, [messages])

	const renderSimpleMessageDialog = () => {
		return (
			<BaseSnoozeDialog
				{...props}
				isOpenDialog={openSimpleMessageDialog}
				onClose={handleCloseSimplesMessageDialog}
				messages={messages}
				snoozeType="message"
				isSaveButtonDisabled={isSaveButtonDisabled}
				userId={userId}
				instanceId={instanceId}
			>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<InputLabel>Mensagem:</InputLabel>
					</Grid>
					<Grid item xs={12}>
						<Messages
							messages={messages || []}
							onSave={setMessages}
						/>
					</Grid>
				</Grid>
			</BaseSnoozeDialog>
		)
	}

	return (
		<Grid container style={{ width: "100%" }}>
			<Grid onClick={handleOpenSimplesMessageDialog} style={{ width: "100%" }}>
				{children}
			</Grid>
			{renderSimpleMessageDialog()}
		</Grid>
	)
}

export default SimpleMessageDialog
